import { Component, OnDestroy } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { GetUserGroupParams, UserGroupGet, UserGroupService } from '@app/services/user-group.service';

@Component({
    selector: 'tt-user-group-view',
    templateUrl: './user-group-view.component.html',
    styleUrls: ['./user-group-view.component.css'],
})
export class UserGroupViewComponent implements OnDestroy {
    public get?: UserGroupGet;

    params: GetUserGroupParams;

    constructor(private state: StateService, private userGroup: UserGroupService) {
        this.userGroup.currentUserGroup$.subscribe({
            next: (value) => {
                if (!!value) {
                    this.get = value;
                } else {
                    delete this.get;
                }
            },
        });

        this.params = this.state.getStateParams() as unknown as GetUserGroupParams;

        this.userGroup.setCurrentUserGroup(this.params);
    }

    public onSubmit(event?: { usergroup_keyno: `${number}` | number }) {
        if (!!event) {
            this.state.go('usergroupedit', event, { location: 'replace' });
        } else {
            this.state.back();
        }
    }

    ngOnDestroy(): void {
        this.userGroup.setCurrentUserGroup(null);
    }
}
